module.exports = __webpack_public_path__ + "img/Botswana.1c23c2c6.svg";